import LaddaButton from "../../../components/buttons/laddaButton";
import ModalComponent from "../../../components/modals";

const CreateVerificationModal = ({ open, onConfirm, onCancel }) => {
  return (
    <ModalComponent
      open={open}
      handleClose={onCancel}
      title="Confirmar orden de servicio"
      width="520px"
      maxWidth="calc(100vw - 32px)"
      actions={
        <div className="HContainer j-center w-complete gap-10" style={{ flexWrap: "wrap" }}>
          <LaddaButton
            type="button"
            color="#6A6AD8"
            backgroundColor={"white"}
            onClick={onCancel}
          >
            <div className="HContainer align-center">
              <p className="button_text">No, cancelar</p>
            </div>
          </LaddaButton>

          <LaddaButton type="button" variant="contained" onClick={onConfirm}>
            <div className="HContainer align-center">
              <p className="button_text">Sí, continuar</p>
            </div>
          </LaddaButton>
        </div>
      }
    >
      <div className="biomedical-service-order-confirmation">
        <img
          src={"/icons/verification_info.png"}
          alt="icon"
        />
        <p className="verification-modal-text">
          Ya existe una orden de servicio con la misma serie, actividad y fecha
          de creación. ¿Desea crear otra orden de servicio?
        </p>
      </div>
    </ModalComponent>
  );
};

export default CreateVerificationModal;
